// extracted by mini-css-extract-plugin
export var dividerLine = "_7h-3";
export var itemImage = "_7h-9";
export var lightDivider = "_7h-4";
export var modalContent = "_7h-5";
export var modalContentCompact = "_7h-6";
export var productCard = "_7h-a";
export var productImage = "_7h-b";
export var productImageCompact = "_7h-7";
export var productImagePlaceholder = "_7h-c";
export var productImagePlaceholderCompact = "_7h-8";
export var progressBarBackground = "_7h-1";
export var progressBarContainer = "_7h-0";
export var progressBarFill = "_7h-2";